// External libraries
import React, { useEffect } from 'react';

// Internal modules
import { logger } from '@/lib';
import { GenericSubmission } from '../../../FormSubmission';
import { Section } from '@/components/Form/StyledComponents';
import { ContactFieldsSection } from '@/components/ContactInformation';
import { GuestTermsAndLegalDisclosure } from '@/components/GuestTermsAndLegalDisclosure';

export const ForcedGuest = (): JSX.Element => {
  useEffect(() => {
    logger.info('rendering_forced_guest_flow');
  }, []);

  return (
    <>
      <Section>
        <ContactFieldsSection />
        <GuestTermsAndLegalDisclosure />
      </Section>
      <GenericSubmission />
    </>
  );
};
